/* eslint-disable import/no-unresolved */
/* eslint-disable import/order */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-key */
/* eslint-disable no-case-declarations */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
import { useParams, useLocation } from 'react-router-dom';
import { useState , useEffect } from 'react';

// @mui
import { styled } from '@mui/material/styles';
import { Divider, Grid, Container} from '@mui/material';
import axios from '../utils/axios';
import { BASE_API } from '../config';
// components
import Page from '../components/Page';
import { AboutHero, AboutWhat, AboutTeam, AboutVision, AboutTestimonials } from '../sections/about';
import {  AppFeatured } from '../sections/@dashboard/general/app';
import { FaqsCategory } from '../sections/faqs';
import Gif from '../components/animate/lottie/39634-cargo.gif'
import VideoV1 from '../sections/newSections/video';
import ItemV1 from '../sections/newSections/item1';
import ItemV2 from '../sections/newSections/item2';
import ImageAndText from '../sections/newSections/imagentext';
import SimpleImage from 'src/sections/newSections/simpleimage';
import { ContactHero } from '../sections/contact';
import ImageV1 from '../sections/newSections/image';
import ContactV1 from '../sections/newSections/contact';
import TextV1 from 'src/sections/newSections/text';
import ImageAndTextV2 from 'src/sections/newSections/imagentextV2';
import EditorV1 from 'src/sections/newSections/editor';
import SliderV1 from 'src/sections/newSections/slider1';
import SliderV2 from 'src/sections/newSections/slider2';
import ItemV3 from 'src/sections/newSections/item3';




// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(8),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(11),
  },
}));

// ----------------------------------------------------------------------

export default function HomePage() {

  const {page , setPage} = useParams();
  const [pageDetail, setPageDetail] = useState([])
  const [loading, setLoading] = useState(false)
  const [slices, setSlices] = useState([])



  useEffect(async ()=>{   
    setLoading(true);
    const getPageDetail = async() => {
      const response = await axios.get(`${BASE_API}/api/blocks/page/home`);
      setPageDetail(response.data)
      console.log(response.data)
    }
    await getPageDetail()
    await aa(pageDetail)
  setLoading(false);
  
  },[]);

  useEffect(()=>{   
    aa(pageDetail)
  },[pageDetail]);

  const aa = async(data) => {
    const sl = []
      data.map((block,index)=>{
        console.log(block)
        switch(block.type) {
             case 'video':
            sl.push(<VideoV1 block={block}/>)
            sl.push(<br/>)
              break;
             case 'simpleimage':
            sl.push(<SimpleImage block={block}/>)
              break; 
             case 'items1':
            sl.push(<ItemV1 block={block}/>)
              break;
              case 'items2':
            sl.push(<ItemV2 block={block}/>)
              break;
              case 'items3':
            sl.push(<ItemV3 block={block} />);
               break;
              case 'imageandtext':
            sl.push(<ImageAndText  block={block}/>)
              break;
              case 'imageandtext2':
            sl.push(<ImageAndTextV2  block={block}/>)
              break;
              case 'image':
            sl.push(<ImageV1  block={block}/>)
              break;
              case 'contact':
            sl.push(<ContactV1  block={block}/>)
              break;
              case 'text':
            sl.push(<TextV1  block={block}/>)
              break;
              case 'editor1':
                sl.push(<EditorV1 block={block} />);
                break;
              case 'slider1':
                sl.push(<SliderV1 block={block}/>);
                break;
              case 'slider2':
                sl.push(<SliderV2 block={block} />);
                break;
            default:
            console.log('Hi Default')          
          } 
          
          return setSlices(sl)
    })
  }
    
  console.log(slices)

  return (

    <Page title="Home">
      <RootStyle >

        <div>
        {slices}
        </div>

        {/* <AboutHero />

        <AboutWhat />

        <Container sx={{ mt: 15, mb: 10 }}>
          <FaqsCategory />
          <Grid item xs={12} md={4}>
            <AppFeatured />
          </Grid>
          </Container>

          <AboutTeam />

        <AboutVision />

        <Divider orientation="vertical" sx={{ my: 10, mx: 'auto', width: 2, height: 40 }} />

        

        <AboutTestimonials /> */} 
        
      </RootStyle>   
    </Page>
  );
}
